import React from "react";
import { Button, Chip, Box, useTheme } from "@mui/material";

interface CellResourceNameProps {
  params: any;
  onClick: (params: any, clickedElement?: string) => void;
  children: React.ReactNode;
}

const CellResourceName = ({ params, onClick, children }: CellResourceNameProps) => {
  const theme = useTheme();
  const type = (params?.row?.type ?? "PAGE") as string;
  const isPage = type === "PAGE";
  const chipLabel = isPage ? "P" : "C";

  const chipSx = {
    height: 20,
    fontSize: "0.7rem",
    fontWeight: 600,
    backgroundColor: isPage ? theme.palette.primary.main : theme.palette.secondary.main,
    color: "white",
    "& .MuiChip-label": { color: "white" },
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <Button
        variant="text"
        size="small"
        tabIndex={params.hasFocus ? 0 : -1}
        sx={{
          width: "fit-content",
          color: "text.primary",
          textDecoration: "underline",
          textTransform: "none",
          fontSize: "14px",
          justifyContent: "flex-start",
          minWidth: 0,
          p: 0,
        }}
        onClick={() => onClick(params)}
      >
        {children}
      </Button>
      <Chip label={chipLabel} size="small" sx={chipSx} />
    </Box>
  );
};

export default CellResourceName;
